import {Action} from '@ngrx/store';
import {Certificate} from '../certificate.model';

export const GET_CERTIFICATE_PROFILE = 'GET_CERTIFICATE_PROFILE';
export const GET_CERTIFICATE_PROFILE_BY_CODE = 'GET_CERTIFICATE_PROFILE_BY_CODE';
export const SET_CERTIFICATE = 'SET_CERTIFICATE';
export const ADD_CERTIFICATE_VIEW = 'ADD_CERTIFICATE_VIEW';

export class GetCertificateProfile implements Action {
  readonly type = GET_CERTIFICATE_PROFILE;

  public constructor(public payload: {id: number, redirect: boolean}) {
  }
}

export class GetCertificateProfileByCode implements Action {
  readonly type = GET_CERTIFICATE_PROFILE_BY_CODE;

  public constructor(public payload: {code: string}) {
  }
}

export class SetCertificate implements Action {
  readonly type = SET_CERTIFICATE;

  public constructor(public payload: Certificate) {
  }
}

export class AddCertificateView implements Action {
  readonly type = ADD_CERTIFICATE_VIEW;

  public constructor(public payload: {code: string}) {
  }
}

export type CertificateActions = GetCertificateProfile | GetCertificateProfileByCode | SetCertificate | AddCertificateView;
